export enum VehicleDataAge {
	UP_TO_DATE = 'upToDate',
	OUTDATED = 'outdated',
	CRITICAL = 'critical',
	MISSING = 'missing',
}
